import { loanTypes } from '~/constants/loanTypes';

export const productType = {
  ['LC_Perm_RI_SPFU_BPI']: loanTypes.immediate,
  ['LC_Nuevas_Adv_BPI']: loanTypes.immediate,
  ['LC_Perm_RI_SPFU_Prem_BPI']: loanTypes.immediate,
  ['LC_Perm_RevIni_SPFU_BPI']: loanTypes.immediate,
  ['LC_Perm_RS_SPFU']: loanTypes.refill,
  ['Sub_Rev_OH']: loanTypes.refill,
  ['LC_Perm_RS_Adva_BPI']: loanTypes.refill,
  ['LC_Perm_RS_Premier_BPI']: loanTypes.refill,
  ['LC_Recom_Rev_Adva_BPI']: loanTypes.refill,
  ['LC_Recom_Rev_Premier_BPI']: loanTypes.refill,
  ['Nva_Rev_OH']: loanTypes.refill,
  ['Simple_Nom_M']: loanTypes.simple,
  ['Simple_CP_M']: loanTypes.simple,
  ['Simple_Nom_A']: loanTypes.simple,
  ['Simple_CP_A']: loanTypes.simple,
  ['Simple_Nom_P']: loanTypes.simple,
  ['Simple_CP_P']: loanTypes.simple,
  ['Simple_CP']: loanTypes.simple,
  ['Simple_Nom']: loanTypes.simple,
  ['Simple_Nom_Saldos_P']: loanTypes.simple,
  ['Nva_TopUp']: loanTypes.topup,
  ['Nva_TopUp_CP']: loanTypes.topup,
  ['TopUp_AN_MB']: loanTypes.topup,
  ['TopUp_CP_MB']: loanTypes.topup,
  ['Simple_Nom_Mob']: loanTypes.simple,
  ['Simple_CP_Mob']: loanTypes.simple,
  ['Pasivos_AN_Mob']: loanTypes.simple,
  ['Pasivos_CP_Mob']: loanTypes.simple,
  ['TopUp_AN_Mob']: loanTypes.topup,
  ['TopUp_CP_Mob']: loanTypes.topup,
  ['Refill_Nom_Mob']: loanTypes.refill,
  ['Refill_CP_Mob']: loanTypes.refill,
  ['Simple_MenoresCP_Mob']: loanTypes.simple,
  ['Simple_MenoresAN_Mob']: loanTypes.simple,
};
